/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Iscallhistoryenabled3Inputs */

const en_entity_iscallhistoryenabled3 = /** @type {(inputs: Entity_Iscallhistoryenabled3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Call History Enabled`)
};

const de_entity_iscallhistoryenabled3 = /** @type {(inputs: Entity_Iscallhistoryenabled3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anrufhistorie aktiviert`)
};

/**
* | output |
* | --- |
* | "Is Call History Enabled" |
*
* @param {Entity_Iscallhistoryenabled3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_iscallhistoryenabled3 = /** @type {((inputs?: Entity_Iscallhistoryenabled3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Iscallhistoryenabled3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_iscallhistoryenabled3(inputs)
	return de_entity_iscallhistoryenabled3(inputs)
});
export { entity_iscallhistoryenabled3 as "entity_isCallHistoryEnabled" }